import type { SiteConfig, FloatingCard } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, ImageField, SelectField, ListEditor } from './fields.tsx';
import { ICON_NAMES } from '../../../lib/icons.ts';

export function HeroSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const hero = config.hero;
  const set = (patch: Partial<SiteConfig['hero']>) => update({ hero: { ...hero, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Hero</h2>
      <TextField label="Badge (petit texte supérieur)" value={hero.badge} onChange={(v) => set({ badge: v })} />
      <TextField label="Titre" value={hero.title} onChange={(v) => set({ title: v })} />
      <TextAreaField label="Sous-titre" value={hero.subtitle} onChange={(v) => set({ subtitle: v })} />
      <TextField label="Texte bouton principal" value={hero.ctaPrimaryText} onChange={(v) => set({ ctaPrimaryText: v })} />
      <TextField label="Lien bouton principal" value={hero.ctaPrimaryUrl} onChange={(v) => set({ ctaPrimaryUrl: v })} />
      <TextField label="Texte bouton secondaire" value={hero.ctaSecondaryText} onChange={(v) => set({ ctaSecondaryText: v })} />
      <TextField label="Lien bouton secondaire" value={hero.ctaSecondaryUrl} onChange={(v) => set({ ctaSecondaryUrl: v })} />
      <ImageField label="Image / mockup" value={hero.image} onChange={(v) => set({ image: v })} />
      <SelectField
        label="Disposition"
        value={hero.layout}
        onChange={(v) => set({ layout: v })}
        options={[
          { value: 'left', label: 'Visuel gauche / texte droite' },
          { value: 'center', label: 'Texte centré' },
          { value: 'right', label: 'Texte gauche / visuel droite' },
        ]}
      />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Cartes flottantes</h3>
      <ListEditor<FloatingCard>
        items={hero.floatingCards}
        onChange={(floatingCards) => set({ floatingCards })}
        itemLabel="une carte"
        newItem={() => ({ text: 'Nouvelle carte', icon: 'check' })}
        renderItem={(card, patch) => (
          <>
            <TextField label="Texte" value={card.text} onChange={(v) => patch({ text: v })} />
            <SelectField
              label="Icône"
              value={card.icon}
              onChange={(v) => patch({ icon: v })}
              options={ICON_NAMES.map((n) => ({ value: n, label: n }))}
            />
          </>
        )}
      />
    </div>
  );
}
